<template>
	<router-view />
</template>

<script>
import { mapGetters } from 'vuex';
import router from '@/router/index.js';

export default {
	created() {
		if (this.isAuthenticated) {
			router.push(
				`/company/${this.user.CurrentEmployeeCompanyId}/dashboard`
			);
		}
	},
	computed: {
		...mapGetters('principal', ['isAuthenticated', 'user'])
	}
};
</script>
